
/*--------------------
* Contact Section
----------------------*/


export default function Contact() {
    return (
        <>
        <section data-scroll-data="4" id="contactus" className="section contactus-section bg-orange-50 relative overflow-hidden" style={{ "backgroundImage": "url(img/effect/bg-effect-3.png)", "backgroundRepeat": "no-repeat", "backgroundSize": "cover", "backgroundPosition": "center"}}>
            <div className="container">
                <div className="grid grid-cols-12">
                    <div className="col-span-12 lg:col-span-6 ">
                        <div className="p-[25px] md:p-[35px] bg-orange-50">
                            <h6 className="text-[32px] font-[600] text-orange-600 mb-[5px]">Tienes dudas, envíanos un mail, nosotros te ayudaremos</h6>
                            <p className="text-[18px] mb-[30px]">Soluciones digitales al alcance de un click ;) </p>
                            <form id="contact-form" method="POST" action="https://formsubmit.co/ccdd2a96ffc31c52ab4e6ad1414ef335">
                                <div className="grid grid-cols-12 gap-3">
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="form-group">
                                            <label className="form-label">Nombre</label>
                                            <input name="Name" id="name" placeholder="Nombre*" className="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="form-group">
                                            <label className="form-label">Email</label>
                                            <input name="Email" id="email" placeholder="tengounaidea@disandev.com *" className="form-control" type="email" />
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="form-group">
                                            <label className="form-label">Asunto</label>
                                            <input name="Subject" id="subject" placeholder="Me pueden contactar, me interesa una página ... *" className="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="form-group">
                                            <label className="form-label">Mensaje</label>
                                            <textarea name="message" id="message" placeholder="Estoy interesado en incorporar inteligencia artificial en mi negocio para mejorar ... *" rows="4" className="form-control"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="send">
                                            <button className="px-btn px-btn-theme2" type="submit">Enviar Mensaje</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-6 flex">
                        <div className="lg:max-w-[410px] w-full lg:ml-auto pt-[50px] lg:pt-0">
                            <div className="pb-10">
                                <img className="w-full" src="img/footerdd_1.webp" title="logoDISanDEV" alt="rostro de chica geek y de chico geek sobre fondo degradado" />
                            </div>
                            <ul className="contact-infos">
                                <li>
                                    <div className="icon bg-4">
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    <div className="col">
                                        <h5>Mail</h5>
                                        <p>info@disandev.com</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon bg-4">
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="col">
                                        <h5>Agenda con nosotros</h5>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
     );
}
